import axios from 'axios';
export default axios.create({
   baseURL: `https://admin.alctravels.com/api/`,
});
